import type { App } from '@grafikr/components';
import header from 'layout/header';

import MarketsSelect from 'components/markets-select';
import pagination from 'components/pagination';
import searchModal from 'components/search-modal';
import drawer from 'components/drawer';
import collectionFilter from 'pages/collection/filter';

import hasUrlParam from 'utils/loaders/has-url-param';
import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from 'utils/loaders/on-event';

export default (app: App) => {
  app.add({
    // Layout
    header,
    'search-modal': searchModal,
    'markets-select': MarketsSelect,

    // Components
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    pagination,
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    slider: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-slider" */ 'components/slider'),
    ],
    'slider-hero': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-slider-hero" */ 'components/slider-hero'),
    ],
    'css-slider': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-css-slider" */ 'components/css-slider'),
    ],
    instafeed: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-instafeed" */ 'components/instafeed'),
    ],
    'overflow-navigation': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-overflow-navigation" */ 'components/overflow-navigation'
        ),
    ],
    'cart-count': [
      onEvent,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    'mega-menu': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-mega-menu" */ 'components/mega-menu'),
    ],
    'mobile-menu': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-mobile-menu" */ 'components/mobile-menu'),
    ],
    collapsible: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-collapsible" */ 'components/collapsible'),
    ],
    'quantity-stepper': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-quantity-stepper" */ 'components/quantity-stepper'),
    ],
    'product-item': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-product-item" */ 'components/product-item'),
    ],
    'external-video': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-external-video" */ 'components/external-video'),
    ],
    drawer,

    // Pages
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-lightbox': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-lightbox" */ 'pages/product/lightbox'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'product-back-in-stock': [
      onElementInteraction,
      () => import(/* webpackChunkName: "product-back-in-stock" */ 'pages/product/back-in-stock'),
    ],
    'collection-filter': collectionFilter,
    'search-filter': [
      intersectionLoader,
      () => import(/* webpackChunkName: "search-filter" */ 'pages/search/filter'),
    ],
    'product-guide-section': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "product-guide-section" */ 'pages/product/product-guide-section'
        ),
    ],
  });
};
